import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LgAuthService } from '@shared/services/auth.service';
import { ButtonModule } from '@bazis/shared/components/web/button/button.module';
import { ColorDirective } from '@bazis/shared/directives/color.directive';
import { BazisModalService } from '@bazis/shared/services/modal.service';
import { TranslocoModule } from '@jsverse/transloco';
import { OnboardingService } from '@pages/shared/services/onboarding.service';

@Component({
    selector: 'app-modal-start-onboarding',
    templateUrl: './modal-start-onboarding.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ButtonModule, TranslocoModule, ColorDirective],
})
export class ModalStartOnboardingComponent {
    public router = inject(Router);

    constructor(
        private modalService: BazisModalService,
        private onboardingService: OnboardingService,
        private authService: LgAuthService,
    ) {}

    startOnboarding() {
        this.modalService.dismiss();

        this.router.navigateByUrl('/objects/geo-zones');

        this.onboardingService.indexCurrentStep$.set(0);
        this.onboardingService.init();
    }

    closeModal() {
        this.modalService.dismiss();
        this.onboardingService.hide();
        this.authService.setOnboardingViewed();
    }
}
